import React, { useState, useEffect, memo } from 'react'
import { useNotify, useStore, useRemoveFromStore } from 'react-admin'
import { Skeleton } from '@mui/material'
import { mapperHelperService } from 'src/services/auth/mapperHelper.service'
import { MapperComponent } from './MapperComponent'
import { findProps } from 'src/helper/FindProps'

export const AdapterToMapperJsonComponent = memo(({ json }) => {
  const notify = useNotify()
  const [loading, setLoading] = useState(false)
  const [jsonMapper, setJsonMapper] = useState({})
  const [path, setPath] = useStore('product.path', '')
  const [checkedNodes, setCheckedNodes] = useState([])
  const [selected, setSelected] = useStore('product.select', [])
  const [selectedItem, setSelectedItem] = useStore('product.treeViewSelectItem')
  const remove = useRemoveFromStore()

  useEffect(() => {
    remove('product.select')
    remove('product.path')
    remove('product.treeViewSelectItem')
  }, [])

  useEffect(() => {
    let path = findProps(jsonMapper, selected)
    if (path) {
      setPath(path)
      setSelectedItem('') // once an item is selected in the skeleton, the item selected in the Tree view will be deselected
      return
    }
    if (!path) {
      if (checkedNodes.length === 0) {
        setPath('')
        setSelectedItem('') // once an item is selected in the skeleton, the item selected in the Tree view will be deselected
        return
      }
      // let indent = []
      // let lenCheckedNodes = checkedNodes.length
      // let lastPosition = checkedNodes[lenCheckedNodes - 1]
      // let isNumber = !isNaN(Number(cleanKey(lastPosition)))
      // if(isNumber){
      //   if(cleanKey(checkedNodes[lenCheckedNodes - 1]) === selected){
      //     indent = checkedNodes[lenCheckedNodes - 1].split("__") //get indent from checkedNodes
      //   }
      // }
      // let select = addIndentIfIsArrayIndex(selected, indent[0])

      // ⇑ to save index position from a array in the path ej: ["productData", "room", "0"] ⇑
      if (checkedNodes.includes(selected)) {
        setPath(checkedNodes)
        setSelectedItem('') // once an item is selected in the skeleton, the item selected in the Tree view will be deselected
        return
      }
    }
  }, [selected, checkedNodes])

  useEffect(() => {
    ;(async () => {
      try {
        if (json.length !== 0) {
          setLoading(true)
          const jsonParse = await mapperHelperService(JSON.parse(json))
          setJsonMapper(jsonParse)
          setLoading(false)
        }
      } catch (error) {
        notify(`json is invalid`, { type: 'error' })
        setLoading(false)
        return
      } finally {
        setLoading(false)
      }
    })()
  }, [json])

  let isNull = { createReservation: {} }
  return (
    <>
      {loading ? (
        <Skeleton variant='rectangular' width={'100%'} height={500} />
      ) : (
        <MapperComponent
          data={jsonMapper ? jsonMapper : isNull}
          setCheckedNodes={setCheckedNodes}
          checkedNodes={checkedNodes}
          setSelected={setSelected}
          selected={selected}
        />
      )}
    </>
  )
})
